<template>
    <v-container fluid fill-height>
        <v-layout column align-start justify-start style="overflow-x: scroll;">

            <v-container fluid pl-0 ml-0>
                <v-layout row color="red">
                    <v-flex xs6 justify-start>
                        <v-btn flat class="grey--text" :to="{name: 'websheet-templates'}">
                            <v-icon>arrow_left</v-icon>
                            Back
                        </v-btn>
                    </v-flex>
                    <v-flex xs6>
                        <h2 class="headline" justify-start>{{template.name}}!</h2>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-divider></v-divider>

            <v-container fluid>
                <v-layout row justify-start>
                    <v-flex xs4>


                        <v-menu style="z-index: 10001"
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="true"
                            
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="bloodslideDate"
                                label="Select Bloodslide Date"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="bloodslideDate" no-title scrollable>
                            <!-- <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu.save(bloodslideDate)">OK</v-btn> -->
                            </v-date-picker>
                        </v-menu>

                        


                    </v-flex>

                    <v-flex xs6>
                        <!-- <v-layout align-end justify-end v-if="template.id != 'microscopy'">
                            <v-btn color="success" @click="switchTemplate('ento_its2')"
                                v-if="template.id != 'ento_its2'">Anoph-Individual</v-btn>
                            <v-btn color="warning" @click="switchTemplate('pcr')" v-if="template.id != 'pcr'">SpeciesID
                            </v-btn>
                            <v-btn color="info" @click="switchTemplate('kdr')" v-if="template.id != 'kdr'">ELISA-Results
                            </v-btn>
                        </v-layout> -->
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid>
                <v-layout row>
                    <v-alert :value="save_message" color="success" icon="check_circle" outline>
                        {{save_message}}
                    </v-alert>
                    <v-alert :value="error_message" color="error" icon="warning" outline>
                        {{error_message}}
                    </v-alert>
                </v-layout>
            </v-container>

            <hot-table ref="hotTableComponent" :settings="settings" licenseKey="non-commercial-and-evaluation" width="100%"></hot-table>
        </v-layout>
    </v-container>
</template>

<script>
import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue'
import HandleErrors from '@/utilities/handle-errors';

    // import {
    //     HotTable
    // } from '@handsontable/vue';
    // import Handsontable from 'handsontable';

    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex'
    import * as _ from 'lodash';

    import {
    HTTP 
    } from '@/utilities/http-common';


    export default {
        components: {
            // HotTable
        },
        mixins: [DashboardBaseTemplate],
        data: function () {
            return {
                save_message: "",
                error_message: "",
                data: [],
                settings: {
                    data: [],
                    stretchH: 'all',
                    rowHeaders: true,
                    colHeaders: [],
                    columns: [],
                    comments: true,
                    licenseKey: 'non-commercial-and-evaluation'
                },
                template: {},
                columns: {},
                dirty: false, // If there is unsaved data in this view.
                periods: ['F01', 'F02', 'F03'],
                period: null,
                bloodslideDate: new Date().toISOString().substr(0, 10),
                templateIDs: ['ento_its2', 'microscopy', 'pcr', 'kdr'],

                // Date picker fields.
                menu: false,
                modal: false,
                menu2: false,
            };
        },
        watch: {
            bloodslideDate () {
                this.search();
            },
        },
        computed: {
            ...mapState('websheet', ['templates']),
            ...mapGetters('websheet', ['getTemplateById'])
        },
        mounted() {
            // this.bloodslideDate = '';
            let templateId = this.$route.params.templateId ? this.$route.params.templateId : 'microscopy';
            if (this.templates.length) {
                this.initWebsheet(templateId);
            } else {
                this.getTemplates().then(response => {
                    this.setTemplates(response.data);
                    this.initWebsheet(templateId);
                }).catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
            }
        },
        methods: {
            ...mapActions(['setAlert']),
            ...mapActions('websheet', ['getTemplates', 'setTemplates', 'getSubjectMicroscopy']),
            save: function () {
                this.dirty = false;
            },
            search: function () {
                let that = this;
                that.settings.data = [];
                that.getSubjectMicroscopy(that.bloodslideDate).then(response => {
                    that.settings.data = response.data;
                });
            },
            switchTemplate: function (templateId) {
                this.initWebsheet(templateId);
            },
            initWebsheet(templateId) {
                let that = this;

                this.template = this.getTemplateById(templateId);
                if (!this.template) {
                    this.setAlert({
                        message: 'Please select a template.',
                        type: 'error'
                    })
                    return this.$router.push({
                        name: 'websheet-templates'
                    });
                }

                that.settings.data = [];// Clear the current data.
                that.settings.colHeaders = [];
                that.settings.colHeaders = _.map(that.template.columns, 'name');// Set the new coluns.
                that.settings.columns = [];

                var data = {};
                _.each(that.template.columns, function (item) {
                    data[item.name] = null;

                    var col = {
                        data: item.name,
                        type: item.type
                    };

                    // Dropdown.
                    if (item.values.length) {
                        col.type = 'dropdown';
                        col.source = item.values;
                    }

                    // Readonly
                    if(that.template.id == "ento_its2" && item.name == 'anoph_id') {
                        col.readOnly = false;
                    } else {
                        col.readOnly = item.readonly;
                    }

                    that.settings.columns.push(col);
                });
                
                that.$refs.hotTableComponent.hotInstance.updateSettings({
                    afterChange: function(changes, source) {
                        if (source == "loadData") {
                            return;
                        }

                        changes.forEach(([row, prop, oldValue, newValue]) => {
                            let col = that.settings.colHeaders.indexOf(prop);
                            
                            const commentsPlugin = that.$refs.hotTableComponent.hotInstance.getPlugin('comments');
                            commentsPlugin.removeCommentAtCell(row, col);
                            
                            const post_data = {};
                            const row_data = that.settings.data[row];
                            post_data[prop] = oldValue;
                            post_data[prop] = newValue;
                            
                            HTTP.put('/kenya/update-subject-microscopy/' + row_data.id, post_data).then(() => {}).catch(error => {
                                that.$refs.hotTableComponent.hotInstance.setCellMeta(row, col, 'valid', false);
                                commentsPlugin.setCommentAtCell(row, col, error.response.data[prop]);
                                commentsPlugin.showAtCell(row, col);
                                that.$refs.hotTableComponent.hotInstance.render();
                            });
                        });
                    },
                    // beforeChange: function(changes, source) {
                    //     if (source == "loadData") {
                    //         return;
                    //     }

                    //     changes.forEach(([row, prop, oldValue, newValue]) => {
                    //         let col = that.settings.colHeaders.indexOf(prop);
                            
                    //         const commentsPlugin = that.$refs.hotTableComponent.hotInstance.getPlugin('comments');
                    //         commentsPlugin.removeCommentAtCell(row, col);
                            
                    //         const post_data = {};
                    //         const row_data = that.settings.data[row];
                    //         post_data[prop] = newValue;
                            
                    //         HTTP.put('/kenya/update-ento-data/' + row_data.id, post_data).then(response => {
                    //             ;
                    //         }).catch(error => {
                    //             that.$refs.hotTableComponent.hotInstance.setCellMeta(row, col, 'valid', false);
                    //             commentsPlugin.setCommentAtCell(row, col, error.response.data[prop]);
                    //             commentsPlugin.showAtCell(row, col);
                    //             that.$refs.hotTableComponent.hotInstance.render();
                    //         });
                    //     });
                    // }
                });

                that.search();
            },
        },
        beforeRouteLeave(to, from, next) {
            if (this.dirty) {
                const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
                if (answer) {
                    next();
                } else {
                    next(false);
                }
            } else {
                next();
            }
        }
    }
</script>

<style>
    @import '~handsontable/dist/handsontable.full.css';

    .ht {
        width: 100%;
    }
</style>
